import { createSlice } from '@reduxjs/toolkit';
import { CurrentVenueType } from 'types/currentEvent';

// initial state
const initialState: CurrentVenueType = { mainData: {}, venueHistories: [] };

// ==============================|| SLICE - VENUE ||============================== //

const currentVenue = createSlice({
  name: 'currentVenue',
  initialState,
  reducers: {
    setCurrentVenue(state, action) {
      state.mainData = action.payload;
    },
    setVenueHistories(state, action) {
      state.venueHistories = action.payload;
    }
  }
});

export default currentVenue.reducer;

export const { setCurrentVenue, setVenueHistories } = currentVenue.actions;
